<div
  *ngIf="
    ctaPosition && ctaPosition.alignmentClass === 'mx-auto';
    else anchorTag
  "
  class="text-center"
>
  <ng-container *ngTemplateOutlet="anchorTag"></ng-container>
</div>

<ng-template #anchorTag>
  <ng-container *ngIf="href; else anchorTagWithoutHref">
    <ng-container *ngTemplateOutlet="anchorTagWithHref"></ng-container>
  </ng-container>
</ng-template>

<ng-template #anchorTagWithHref>
  <a
    [class]="linkClasses"
    [ngClass]="buttonClasses"
    [href]="href"
    [attr.data-analytics-text]="analyticsLinkText"
    rel="noopener"
    (click)="navigate($event, href)"
  >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </a>
</ng-template>

<ng-template #anchorTagWithoutHref>
  <a
    role="button"
    [class]="linkClasses"
    [ngClass]="buttonClasses"
    [attr.data-analytics-text]="analyticsLinkText"
    rel="noopener"
    (click)="navigate($event, href)"
  >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </a>
</ng-template>

<ng-template #buttonContent>
  <ng-container
    *ngIf="cmsUrlData[0] && cmsUrlData[0].title; else contentProjection"
  >
    {{ cmsUrlData[0].title }}
  </ng-container>

  <ng-template #contentProjection>
    <ng-content></ng-content>
  </ng-template>
  <span *ngIf="chevron" class="cta-button-right-chevron mx-4">
    <digital-platform-icon icon="chevron-right-solid"></digital-platform-icon>
  </span>
  <span
    *ngIf="ctaStyle && ctaStyle?.ctaStyle === 'button__link'"
    class="cta-button-right-arrow mx-3"
  >
    <digital-platform-icon icon="arrow-right-solid"></digital-platform-icon>
  </span>
</ng-template>
